module.exports = __webpack_public_path__ + "static/media/Veridium-Logo.fb30a711.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/Veridium-Logo.png
// module id = 1057
// module chunks = 0